import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Accordion)`
  background: ${(p) => p.theme.palette.grey[50]};
  display: flex;
  flex-direction: column;
  padding: ${(p) => p.theme.spacing(1.5)};
  border: 1px solid ${(p) => p.theme.palette.grey[50]};

  &.MuiAccordion-root {
    &::before {
      display: none;
    }
  }
  &.Mui-expanded {
    gap: ${(p) => p.theme.spacing(1.5)};
    box-shadow: none;
    border-radius: ${(p) => p.theme.spacing(0.5)};
  }
  border-radius: ${(p) => p.theme.spacing(0.5)} !important;

  &.not-added {
    border: 1px dashed ${(p) => p.theme.palette.grey[300]};
    cursor: default;

    & .MuiAccordionSummary-root {
      cursor: default;
    }
  }

  &.is-single {
    background: ${(p) => p.theme.palette.common.white} !important;
    padding: 0 !important;
    border: none !important;
  }

  & .MuiAccordionSummary-root {
    min-height: ${(p) => p.theme.spacing(3)} !important;
    padding: 0 !important;
  }
`;

export const Summary = styled(AccordionSummary)`
  & .MuiAccordionSummary-content {
    margin: 0 !important;
    overflow: hidden !important;
  }
`;

export const Detail = styled(AccordionDetails)`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing(1.5)};
  padding: 0 !important;
`;
